import { z } from "zod";

const CreateInventorySchema = z.object({
    property_id: z.string().uuid("Invalid property ID"),
    category_id: z.string().uuid("Invalid category ID"),
    item_name: z.string().min(1, "Item name is required"),
    price: z.number().min(0, "Price must be 0 or greater"),
});

export { CreateInventorySchema };
export type CreateInventoryFormData = z.infer<typeof CreateInventorySchema>;
